import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './ExtendWarrantyPlaceholder.module.scss';

import ExtendWarrantyHeading from '../ExtendWarrantyHeader';

const ExtendWarrantyPlaceholder = ({
  placeholderId,
  productType,
  detectedWarrantyPlansForPlaceholders,
  selectedProduct = null,
}) => {
  const isExtendEnabled = process.env.IS_EXTEND_ENABLED === 'true';

  if (!isExtendEnabled) {
    return null;
  }
  return (
    <div
      className={classnames({
        [styles['bedframe-aov-margin']]: productType === 'bed_frames',
        [styles.offer]: detectedWarrantyPlansForPlaceholders
          ?.[`${placeholderId}-${selectedProduct}`],
      })}
    >
      {detectedWarrantyPlansForPlaceholders?.[`${placeholderId}-${selectedProduct}`] && (
        <ExtendWarrantyHeading productType={productType} />
      )}
      <div id={placeholderId} />
    </div>
  );
};

ExtendWarrantyPlaceholder.propTypes = {
  placeholderId: PropTypes.string.isRequired,
  productType: PropTypes.string.isRequired,
  detectedWarrantyPlansForPlaceholders: PropTypes.object.isRequired,
  selectedProduct: PropTypes.string,
};

export default ExtendWarrantyPlaceholder;
